import { List, ListProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { ShopListItem as OccupantListItem } from "components/domains/directory"
import { IFeature } from "interfaces"
export interface IFeatureListDetailProps extends Pick<ListProps, "sx"> {
  list: IFeature[]
  loading: boolean
}

export const FeatureListDetail: React.FC<IFeatureListDetailProps> = ({
  list: dataList,
  loading,
  sx = {},
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`FeatureListDetail`]?.styleOverrides || {}
  const { list, listItem } = styleOverrides

  if (loading) {
    return null
  }

  return (
    <List sx={deepmerge(list, sx)}>
      {dataList.map((occupant) => (
        <OccupantListItem
          key={occupant.id}
          sx={listItem}
          className="FeatureListDetail-listItem"
          occupant={occupant}
        />
      ))}
    </List>
  )
}
